import React, {Suspense, lazy} from 'react';
import {HashRouter, Route, Switch} from "react-router-dom";
import FullScreenLoader from "./Components/Common/FullScreenLoader";
const HomePage =lazy(() => import('./Pages/Home/HomePage'));
const App = () => {
    return (
        <HashRouter>
            <Suspense fallback={<FullScreenLoader/>}>
            <Switch>
                <Route exact path="/" render={(props) => <HomePage {...props} key={Date.now()} />}/>
            </Switch>
            </Suspense>
        </HashRouter>
    );
};
export default App;